
export default class PrivacyPolicyAgreementViewModel {
    constructor(data) {
        this.kind = data.kind;
        this.version = data.version;
    }
}